import React from "react";
import withStyles from '@mui/styles/withStyles';

const styles = (theme) => ({
  root: {},
  selected: {
    background: "#238CB9",
    padding: "4px 13px",
    borderRadius: "30px",
    color: "#ffffff",
    width: "inherit",
  },
  routelink: {
    textTransform: "uppercase",
    fontFamily: "Montserrat",
    fontWeight: 600,
    fontSize: "12px",
    whiteSpace: "nowrap",
    margin: "0px 7px",
    color: "#8C8C96",
  },
});

const PointsRouteLink = ({
  classes,
  title,
  selectedRouteName,
  routeName,
  setRouteName,
}) => {
  return (
    <div className={classes.routelink} onClick={(e) => setRouteName(routeName)}>
      <div
        style={{ display: "flex", width: "min-content" }}
        className={[
          selectedRouteName === routeName
            ? classes.selected
            : classes.unselected,
        ]}
      >
        <div
          style={{
            whiteSpace: "pre-wrap",
            overflowWrap: "break-word",
            textAlign: "center",
          }}
        >
          {title}
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(PointsRouteLink);
